/*eslint-disable*/
import React ,{useEffect} from "react";
import {connect} from 'dva';
import EmailVerify from './EmailVerify'

function List(props) {

    const { currentItem,leaveMsgList,LOCALE_HTML,dispatch ,deployConfigInfo} = props;

    const { uid, sysNum, token = '' } = window.urlObject;
    useEffect(()=> {
        if(currentItem){
            if (token) {
                dispatch({
                    type: 'leaveMsg/getMsgRecordList',
                    payload: {
                        token: decodeURIComponent(token),
                        ticketScopeFlag: deployConfigInfo.item.ticketScopeFlag
                    }
                })
            } else {
                dispatch({
                    type: 'leaveMsg/getMsgRecordList',
                    payload: {
                        uid,
                        ticketScopeFlag: deployConfigInfo.item.ticketScopeFlag
                    }
                })
            }
        }
    },[currentItem]);
  
        const handleClick = (ticketId, showType) => {

        dispatch({
            type: 'leaveMsg/getLeaveMsgDetail',
            payload:{
                uid,
                param:{
                    companyId:sysNum,
                    ticketId,
                    showType
                }
            },
        });
    };

    return (
        <div className="msg-record-list-wrap">
            {
                leaveMsgList.length > 0 ? leaveMsgList.map((item,index) => {
                    let status = '',text = '';
                    if(item.flag === 1){
                        status = 'created';
                        text = LOCALE_HTML['msg.status.created'];
                    }else if(item.flag === 2){
                        status = 'procressd';
                        text = LOCALE_HTML['msg.status.processing'];
                    }else if(item.flag === 3){
                        status = 'completed';
                        text = LOCALE_HTML['msg.status.solved'];
                    }
                    if (item.revocation === 1 && item.ticketStatus === 99) {
                        status = 'revoked';
                        text = LOCALE_HTML['msg.status.revoked'];
                    }
                    return (
                        <div key={index} className="msg-record-item" onClick={()=>handleClick(item.ticketId, 4)}>
                            <div className="msg-record-item-top">
                                <div className="time">{item.timeStr} { item.newFlag === 2 ? <svg><use xlinkHref="#iconNEW"/></svg> : null }</div>
                                <div className={`status ${status}`}>{text}</div>
                            </div>
                            <div className="msg-record-item-desc" dangerouslySetInnerHTML={{__html: item.content}}>
                                {/* {item.content} */}
                            </div>
                        </div>
                    )
                }) : <EmailVerify></EmailVerify>
            }
        </div>
    )
}

function mapState(state) {
    const {currentItem,leaveMsgList} = state.leaveMsg;
    const { LOCALE_HTML } = state.locale;
    const {deployConfigInfo} = state.app;
    return {
        currentItem,
        leaveMsgList,
        LOCALE_HTML,
        deployConfigInfo
    }
}

export default connect(mapState)(List);